import { addMinutes } from 'date-fns';
import type { Event } from 'models';
import { useCallback } from 'react';
import { useGetStartDateTime } from '../../../components';
import type { DuplicateEventRequestData } from '../../../queries';
import type { DuplicateEventFormValues } from '../DuplicateEventForm';

export const useCreateFormRequestData = () => {
  const getStartDateTime = useGetStartDateTime();

  return useCallback(
    (formValues: DuplicateEventFormValues, event: Event): DuplicateEventRequestData => {
      const startTime = getStartDateTime({ startDate: formValues.startDate, startTime: formValues.startTime });
      const endTime = addMinutes(startTime, formValues.duration);

      return {
        data: {
          channel: {
            featuredInChannels: formValues.featuredInChannels,
            organization: formValues.organization?.value,
            showInChannel: formValues.showInChannels,
            tags: formValues.tags,
          },
          distributionList: formValues.duplicateInviteesFromEvent ? event.distributionList : undefined,
          endTime: endTime.toISOString(),
          html: formValues.htmlDescription,
          name: formValues.name,
          startTime: startTime.toISOString(),
          text: formValues.textDescription,
          type: formValues.type,
        },
        duplicateParticipantsFrom: formValues.duplicateInviteesFromEvent ? event.id : undefined,
      };
    },
    [getStartDateTime],
  );
};
